import { render, staticRenderFns } from "./DesignPicker.vue?vue&type=template&id=07fc3423&scoped=true&"
import script from "./DesignPicker.vue?vue&type=script&lang=js&"
export * from "./DesignPicker.vue?vue&type=script&lang=js&"
import style0 from "./DesignPicker.vue?vue&type=style&index=0&id=07fc3423&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fc3423",
  null
  
)

export default component.exports